export default __webpack_public_path__ + "static/media/logo-kpsg.e81fc80d.png";